module.exports = __webpack_public_path__ + "e862f986b80095500dfd7bd21bb8b9de.svg";